<template>
  <section class="partners">
    <div class="partners-form">
      <div class="partners-form-inner">
        <h1>CONTACT US</h1>
        <div class="partners-form-flex">
          <el-form
            :model="formData"
            ref="formDataRef"
            :rules="rules"
            label-width="auto"
            size="normal"
            label-position="top"
          >
            <el-form-item label="" prop="firstName">
              <el-input
                v-model="formData.firstName"
                placeholder="姓氏*"
              ></el-input>
            </el-form-item>
            <el-form-item label="" prop="lastName">
              <el-input
                v-model="formData.lastName"
                placeholder="名字*"
              ></el-input>
            </el-form-item>
            <el-form-item label="" prop="companyName">
              <el-input
                v-model="formData.companyName"
                placeholder="公司名称*"
              ></el-input>
            </el-form-item>
            <el-form-item label="" prop="country">
              <el-select
                v-model="formData.country"
                placeholder="国家*"
                clearable
                style="width: 100%"
              >
                <el-option
                  v-for="item in countryList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="" prop="email">
              <el-input v-model="formData.email" placeholder="邮箱*"></el-input>
            </el-form-item>
            <el-form-item label="" prop="phoneNumber">
              <el-input
                v-model="formData.phoneNumber"
                placeholder="电话号码*"
              ></el-input>
            </el-form-item>
            <el-form-item label="" prop="remark" style="width: 100%">
              <el-input
                type="textarea"
                v-model="formData.remark"
                placeholder="查询详情*"
                rows="4"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <a class="btn" @click="onSubmit">提 交</a>
            </el-form-item>
          </el-form>
          <ul>
            <li>
              <div>
                <h3>香港美格科技有限公司</h3>
                <h4>HONGKONG MEGA TECHNOLOGY LIMITED</h4>
              </div>
            </li>
            <li>
              <i class="iconfont icon-dianhua"></i>
              <p>+852 2654 4488</p>
            </li>
            <li>
              <i class="iconfont icon-youxiang"></i>
              <p>marketing@mag-chn.com</p>
            </li>
            <li>
              <i class="iconfont icon-dizhi"></i>
              <p>
                UNIT 1406A, 14/F, THE BELGIAN BANK BUILDING, NOS. 721 - 725
                NATHAN ROAD, MONG KOK HONG KONG
              </p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import country from '@/data/country.json'
export default {
  name: 'ContactUs',
  data() {
    return {
      formData: {
        firstName: '',
        lastName: '',
        email: '',
        phoneNumber: '',
        companyName: '',
        companyWebsite: '',
        country: '',
        remark: ''
      },
      rules: {
        firstName: [
          {
            required: true,
            message: '请填写此必填字段',
            trigger: ['blur', 'change']
          }
        ],
        lastName: [
          {
            required: true,
            message: '请填写此必填字段',
            trigger: ['blur', 'change']
          }
        ],
        email: [
          {
            required: true,
            message: '请填写此必填字段',
            trigger: ['blur', 'change']
          }
        ],
        phoneNumber: [
          {
            required: true,
            message: '请填写此必填字段',
            trigger: ['blur', 'change']
          }
        ],
        companyName: [
          {
            required: true,
            message: '请填写此必填字段',
            trigger: ['blur', 'change']
          }
        ],
        country: [
          {
            required: true,
            message: '请填写此必填字段',
            trigger: ['blur', 'change']
          }
        ],
        remark: [
          {
            required: true,
            message: '请填写此必填字段',
            trigger: ['blur', 'change']
          }
        ]
      },
      countryList: country
    }
  },
  methods: {
    onSubmit() {
      this.$refs['formDataRef'].validate(valid => {
        if (valid) {
          console.log(this.formData)
        } else {
          this.$message.warning('有必填项未填写，请填写必填字段')
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.partners {
  border-bottom: 1px solid #2a2b2f;
  .partners-head {
    padding: 0 5%;
    height: 530px;
    background: url('../../assets/partners/Screenshot-2024-10-01-125924.png')
      50% 50%;
    background-size: cover;
    .partners-head-inner {
      width: 1140px;
      margin: 0 auto;
      padding: 150px 0;
      h1 {
        width: 350px;
        margin-bottom: 20px;
        font-size: 48px;
      }
      p {
        width: 350px;
      }
    }
  }
  .partners-tab {
    padding: 0 5%;
    background-color: #fff;
    .partners-tab-inner {
      width: 1140px;
      margin: 0 auto;
      padding: 50px 0 80px;
      ul {
        display: flex;
        gap: 10px;
        li {
          flex: 1;
          padding: 15px 35px;
          border-bottom: 4px solid #2a2c2f1a;
          text-align: center;
          transition: all 0.5s;
          .icon {
            height: 25px;
            position: relative;
            img {
              width: 25px;
              height: 25px;
              position: absolute;
              top: 0;
              left: 50%;
              transform: translateX(-50%);
              transition: all 0.5s;
            }
            .image {
              opacity: 1;
            }
            .image-action {
              opacity: 0;
            }
          }
          h3 {
            margin-top: 15px;
            font-size: 14px;
          }
          &:hover {
            border-color: #2f5ad9;
            color: #2f5ad9;
            .image {
              opacity: 0;
            }
            .image-action {
              opacity: 1;
            }
          }
        }
        .action {
          border-color: #2f5ad9;
          color: #2f5ad9;
          .icon .image {
            opacity: 0;
          }
          .icon .image-action {
            opacity: 1;
          }
        }
      }
      .list {
        margin: 45px 0 25px;
        display: grid;
        grid-template-columns: repeat(6, 1fr);
        grid-gap: 50px;
        .list-item {
          height: 100px;
          border: 1px solid #2a2c2f1a;
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          img {
            width: 75%;
          }
          img[alt] {
            filter: brightness(0%) contrast(100%) saturate(100%) blur(0px)
              hue-rotate(0deg);
          }
        }
      }
    }
  }
  .partners-btn {
    padding: 0 5%;
    background-color: #fbfbfc;
    .partners-btn-inner {
      width: 1140px;
      margin: 0 auto;
      padding: 40px 0;
      display: flex;
      align-items: center;
      justify-content: center;
      a {
        padding: 16px 40px;
        border: 3px solid #2a2b2f;
        border-radius: 40px;
        font-size: 18px;
        font-weight: 700;
        color: #2a2b2f;
        transition: all 0.5s;
        &:hover {
          color: #2f5ad9;
          border-color: #2f5ad9;
        }
      }
    }
  }
  .partners-form {
    padding: 100px 5%;
    background-color: #f5f5f6;
    .partners-form-inner {
      width: 1140px;
      background-color: #fff;
      margin: 0 auto;
      box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.15);
      padding: 35px 60px 60px;
      box-sizing: border-box;
      h1 {
        width: 100%;
        font-size: 40px;
        margin-bottom: 20px;
      }
      .partners-form-flex {
        display: flex;
        gap: 60px;
      }
      .el-form {
        width: 478px;
        display: flex;
        flex-wrap: wrap;
        flex-grow: 0;
        gap: 10px;
        .logo {
          width: 100%;
          margin-bottom: 18px;
          .logo-inner {
            width: 256px;
            height: 60px;
            box-shadow: gray 0px 0px 5px;
          }
        }
        .el-form-item {
          width: 229px;
          .btn {
            padding: 10px 40px;
            background-color: #2f5ad9;
            border-radius: 50px;
            color: #fff;
            font-size: 16px;
            font-weight: 700;
            transition: all 0.5s;
            &:hover {
              background-color: #f08f72;
            }
          }
        }
      }
      ul {
        flex: 1;
        line-height: 2em;
        font-size: 14px;
        li {
          display: flex;
          margin-bottom: 8px;
          h3 {
            font-size: 22px;
          }
          h4 {
            font-size: 16px;
            margin: 4px 0 12px 0;
          }
          .iconfont {
            margin-right: 10px;
          }
        }
      }
    }
  }
}
</style>
